export default __webpack_public_path__ + "static/tryout-d3d35aade48c2dd2a3e191f1c2fbeb1f.png";